<template>
  <div class="row main-content">
    <div class="col">
      <h1 class="page-title font-custom text-uppercase mt-3">
        {{ $t('title.account.list') }}
      </h1>

      <div class="card rounded-0 mb-4">
        <form class="card-body">
          <div class="row mb-2">
            <!-- Distributor -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.account.selectedDistributorRef') }} *
              </label>
              <select
                v-model="criterias.selectedDistributorRef"
                :disabled="isDistributorLocked"
                :class="status(v$.criterias.selectedDistributorRef)"
                name="distributor"
                class="form-control rounded-0 form-select"
                placeholder="$t('label.account.selectedDistributorRef')"
                @change="updateComProducts()"
              >
                <option
                  value
                  selected
                  disabled
                  hidden
                >
                  {{ $t('label.account.selectedDistributorRef') }}
                </option>
                <option
                  v-for="distributor in distributors"
                  :key="distributor.id"
                  :value="distributor"
                >
                  {{ distributor }}
                </option>
              </select>
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.selectedDistributorRef.required.$invalid">{{ $t('error.VALIDATION_MANDATORY_CRITERIA') }}</span>
              </p>
            </div>

            <!-- Produit commercial -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.account.selectedCommercialProduct') }}
              </label>
              <select
                v-model="criterias.selectedCommercialProduct"
                name="commercialProduct"
                class="form-control rounded-0 form-select"
                :class="status(v$.criterias.selectedCommercialProduct)"
                :data-placeholder="$t('label.account.selectedCommercialProduct')"
              >
                <option
                  value
                  selected
                  disabled
                  hidden
                >
                  {{ $t('label.account.selectedCommercialProduct') }}
                </option>
                <option
                  v-for="product in comProducts"
                  :key="product.id"
                  :value="product"
                >
                  {{ product }}
                </option>
              </select>
            </div>

            <!-- Contrat financeur -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.account.selectedFunderContract') }}
              </label>
              <input
                v-model="criterias.selectedFunderContract"
                type="text"
                class="form-control rounded-0"
                :placeholder="$t('label.account.selectedFunderContract')"
              >
            </div>

            <!-- Service beneficiaire -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.account.selectedBeneficiaryService') }}
              </label>
              <input
                v-model="criterias.selectedBeneficiaryService"
                type="text"
                class="form-control rounded-0"
                :placeholder="$t('label.account.selectedBeneficiaryService')"
              >
            </div>
          </div>

          <div class="row mb-2">
            <!-- Account Status -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.account.selectedAccountStatus') }}
              </label>
              <select
                v-model="criterias.selectedAccountStatus"
                name="accountStatus"
                class="form-control rounded-0 form-select"
                :placeholder="$t('label.account.selectedAccountStatus')"
              >
                <option
                  value
                  selected
                  disabled
                  hidden
                >
                  {{ $t('label.account.selectedAccountStatus') }}
                </option>
                <option
                  v-for="type in accountStatus"
                  :key="type.id"
                  :value="type"
                >
                  {{ type }}
                </option>
              </select>
            </div>

            <!-- Start Date traitement-->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.account.selectedCreationDate') }}
              </label>
              <input
                v-model="criterias.selectedCreationDate"
                type="date"
                class="form-control rounded-0"
                placeholder="yyyy-MM-dd"
              >
            </div>

            <div class="col justify-content-end text-end criteria-button">
              <button
                type="button"
                class="btn btn-default btn-reset rounded-pill font-custom me-2"
                @click="reset()"
              >
                {{ $t('button.reset') }}
              </button>
              <button
                class="btn btn-primary btn-submit rounded-pill font-custom text-uppercase font-inverted"
                type="button"
                @click="search()"
              >
                <i class="fa fa-search me-1" />
                {{ $t('button.search') }}
              </button>
            </div>
          </div>
        </form>
      </div>

      <div v-if="$store.state.accounts.accounts.length">
        <!-- div class="card card-body bg-light mb-4">
          <button
            @click="downloadCSV()"
            type="button"
            class="btn btn-primary rounded-pill font-custom font-inverted btn-export">
            <i class="far fa-file-excel me-1"></i>
            {{ $t('button.export') }}
          </button>
        </div -->

        <div class="table-responsive">
          <table
            class="table table-hover table-sm table-striped border"
            style="white-space:nowrap;"
          >
            <thead>
              <tr>
                <th>{{ $t('label.account.distributorRef') }}</th>
                <th>{{ $t('label.account.productRef') }}</th>
                <th>{{ $t('label.account.selectedFunderContract') }}</th>
                <th>{{ $t('label.account.selectedBeneficiaryService') }}</th>
                <th>{{ $t('label.account.status') }}</th>
                <th>{{ $t('label.account.selectedCreationDate') }}</th>
                <th>{{ $t('label.account.singleFunderAccount') }}</th>
                <th>{{ $t('label.actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="account in displayedAccounts"
                :key="account.id"
                class="mb-3"
              >
                <td>{{ account.distributorRef }}</td>
                <td>{{ account.productRef }}</td>
                <td>{{ account.funderContractRef }}</td>
                <td>{{ account.beneficiaryServiceRef }}</td>
                <td>
                  {{ account.accountStatus }}
                  <span
                    v-if="account.singleFunderAccount && !account.beneficiaryServiceRef"
                    :title="$t('label.account.dataFromCFU')"
                    data-bs-toggle="tooltip"
                    data-bs-placement="left"
                    class="label label-default ms-2"
                  >
                    <i class="fa fa-info-circle fa-xs" />
                  </span>
                  <span
                    v-else
                    :title="$t('label.account.dataFromSB')"
                    data-bs-toggle="tooltip"
                    data-bs-placement="left"
                    class="label label-default ms-2"
                  >
                    <i class="fa fa-info-circle fa-xs" />
                  </span>
                </td>
                <td>
                  {{ $filters.dateYYYYMMDD(account.creationDate) }}
                  <span
                    v-if="account.singleFunderAccount && !account.beneficiaryServiceRef"
                    :title="$t('label.account.dataFromCFU')"
                    data-bs-toggle="tooltip"
                    data-bs-placement="left"
                    class="label label-default ms-2"
                  >
                    <i class="fa fa-info-circle fa-xs" />
                  </span>
                  <span
                    v-else
                    :title="$t('label.account.dataFromSB')"
                    data-bs-toggle="tooltip"
                    data-bs-placement="left"
                    class="label label-default ms-2"
                  >
                    <i class="fa fa-info-circle fa-xs" />
                  </span>
                </td>
                <td>
                  <svg
                    v-if="account.singleFunderAccount"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="#f79000"
                    class="bi bi-check"
                    viewBox="0 0 16 16"
                  >
                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                  </svg>
                  <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    class="bi bi-x"
                    viewBox="0 0 16 16"
                  >
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                  </svg>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary border-secondary rounded-pill font-custom"
                    @click="showDetails(account)"
                  >
                    {{ $t('button.detail') }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <Pager
          :posts="$store.state.accounts.accounts"
          @page-update="displayedAccounts = $event;"
        />
      </div>

      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="center-block lazyload"
        >
      </div>

      <div
        v-else-if="error"
        class="alert alert-warning text-center border-0 shadow-sm rounded-0"
      >
        {{ $t('error.'+`${responseErr}`) }}
      </div>
    </div>
  </div>
</template>

<script src="./AccountList.js"></script>

<style src="./AccountList.scss" scoped lang="scss"></style>
